import { render, staticRenderFns } from "./faultdist.vue?vue&type=template&id=2bcb9c44&"
import script from "./faultdist.vue?vue&type=script&lang=js&"
export * from "./faultdist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports